export enum MembersAreaRouteType {
  Profile = 'Profile',
  Settings = 'Settings',
}
